import errorMessage from 'global_config/error_messages';

const FIELD_RULES = {
	dateCategory: [
    { 
			required: false, 
			message: errorMessage.required 
		}
	],
	dateSpan: [
    { 
			required: false, 
			message: errorMessage.required }
	],
	status: [
    { 
			required: true, 
			message: errorMessage.required 
		}
	],
	patientID: [
    { 
			// pattern: '^[0-9]+$', 
			pattern: '[0-9]', 
			// message: 'Numeric only and Max Length is 15',
			max: 15
		}
	],
	patientName: [
		{ 
			max: 100, 
			message: errorMessage.maxLength(100)
		},
		// { 
		// 	pattern: '^[a-zA-Z0-9äöüÄÖÜ]*$', 
		// 	message: 'Special characters are not allowed.'
		// }
	],
	sampleSpecimenID: [
		{ 
			max: 15, 
			message: errorMessage.maxLength(15)
		},
		// { 
		// 	pattern: '^[a-zA-Z0-9äöüÄÖÜ]*$', 
		// 	message: 'Special characters are not allowed.'
		// }
	],
};

export default FIELD_RULES;
